'use strict';

var React = require('react'),
    _ = require('underscore'),
    UserInfo = require('../organisms/UserInfo'),
    PureRenderMixin = require('../mixins/PureRenderMixin'),
    Icon = require('../atoms/Icon'),
    ServiceTypes = require('../constants/ServiceTypes');

require('./ContactList.less');

var ContactList = React.createClass({
  mixins: [PureRenderMixin],

  propTypes: {
    contacts: React.PropTypes.array.isRequired,
    onSelect: React.PropTypes.func.isRequired
  },

  render: function () {
    var contacts = _.map(this.props.contacts, this.renderContact);
    return (
      <ul className='ContactList'>
        {contacts}
      </ul>
    );
  },

  renderContact: function (contact) {
    return (
      <li className='ContactList-item'
          onMouseDown={this.props.onSelect.bind(this, contact)}
          key={contact.id}>
        <UserInfo user={contact}
                  size='xsmall'
                  noLink>
          <div className='ContactList-description'>
            {this.renderDescription(contact)}
          </div>
        </UserInfo>
      </li>
    );
  },

  renderDescription: function (friend) {
    var serviceType = friend.serviceType,
        description,
        icon,
        mode;

    switch (serviceType) {
    case ServiceTypes.GOOGLE:
      description = friend.email;
      icon = 'email';
      mode = 'stroke';
      break;
    case ServiceTypes.FACEBOOK:
      description = 'Facebook Message';
      icon = 'facebook';
      mode = 'fill';
      break;
    }

    return {
      icon: <Icon name={icon}
                  size='xsmall'
                  mode={mode} />,
      description: description && <span>{description}</span>
    };
  }
});

module.exports = ContactList;



/** WEBPACK FOOTER **
 ** ./organisms/ContactList.jsx
 **/